import React from "react"

export const GlobalStateContext = React.createContext()
export const GlobalDispatchContext = React.createContext()

const initialState = {
  branch: "All Branches",
  emergencyBanner: true
}

function reducer(state, action) {
  switch (action.type) {
    case "UPDATE_BRANCH": {
      return {
        ...state,
        branch: action.branch,
      }
    }
    case "BANNER_DISPLAYED": {
      return {
        ...state,
        emergencyBanner: !state.emergencyBanner
      }
    }
    default:
      throw new Error("Bad Action Type")
  }
}

const GlobalContextProvider = ({ children }) => {
  const [state, dispatch] = React.useReducer(reducer, initialState)
  return (
    <GlobalStateContext.Provider value={state}>
      <GlobalDispatchContext.Provider value={dispatch}>
        {children}
      </GlobalDispatchContext.Provider>
    </GlobalStateContext.Provider>
  )
}

export default GlobalContextProvider
